module.exports = __webpack_public_path__ + "static/img/tab-one.6dbd92db.png";